<template>
  <div>
    <vx-card class="w-full mb-6">
      <vs-table ref="resourceTable" stripe class="vs-con-loading__container" single @selected="handleSelectedResource" pagination :max-items="itemsPerPage" search :data="resource" v-scroll-to="'#resourceInfoCard'">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
          <div class="flex flex-wrap-reverse items-center">
            <!-- ADD NEW -->
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showDetailsCard" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>

          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ resource.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : resource.length }} of {{ resource.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="description">Description</vs-th>
          <vs-th sort-key="resourceCategoryName">Category</vs-th>
          <vs-th sort-key="moduleGroupName">Term</vs-th>
          <vs-th sort-key="courseClassificationName">Grade</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="resource" :key="indextr" v-for="(resource, indextr) in data">

            <vs-td :data="data[indextr].name">
              {{ resource.name }}
            </vs-td>
            <vs-td :data="data[indextr].description">
              {{ resource.description }}
            </vs-td>
            <vs-td :data="data[indextr].resourceCategoryName">
              {{ resource.resourceCategoryName ? resource.resourceCategoryName : "N/A" }}
            </vs-td>
            <vs-td :data="data[indextr].moduleGroupName">
              {{ resource.moduleGroupName ? resource.moduleGroupName : "N/A" }}
            </vs-td>
            <vs-td :data="data[indextr].courseClassificationName">
              {{ resource.courseClassificationName ? resource.courseClassificationName : "N/A" }}
            </vs-td>
            

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card id="resourceInfoCard" ref="resourceInfo" class="mb-6" :title="resourceCardTitle" v-show="!isInfoHidden">
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2 w-full">
          <label>Name</label>
          <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-model="formData.name" />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>Description</label>
          <vs-textarea autocomplete="off" onClick="this.select();" class="w-full" v-model="formData.description" />
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2 w-full">
          <label>Resource Category</label>
          <v-select
              ref="resourceDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select Category"
              :options="resourceList"
              v-model="resourceDropdown"
              :clearable="false"
          >
            <span slot="no-options" style="color: rgb(202, 202, 202)">No Resource Category have been made yet.</span>
          </v-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>Term</label>
          <v-select
              ref="termDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select Term"
              :options="termList"
              v-model="termDropdown"
              :clearable="true"
          >
            <span slot="no-options" style="color: rgb(202, 202, 202)">No Terms have been made yet.</span>
          </v-select>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2 w-full">
          <label>Grade</label>
          <v-select
              ref="gradeDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select Grade"
              :options="gradeList"
              v-model="gradeDropdown"
              :clearable="true"
          >
              <span slot="no-options" style="color: rgb(202, 202, 202)">No Grades have been made yet.</span>
          </v-select> 
        </div>
      </div>

      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveEditResource" ref="saveEditButton">Save</vs-button>
          <vs-button v-if="formData.id" color="danger"  class="mr-5 mb-2 vs-con-loading__container" @click.prevent="deleteResource" ref="deleteButton">Delete</vs-button>
          <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#resourceInfoCard'" @click="cancelAdd">Cancel</vs-button>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>

import vSelect from 'vue-select'

  export default {
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        loadingColor:'#fff',
        selected: [],
        itemsPerPage: 10,
        isMounted: false,
        isInfoHidden: true,
        resource: [],
        formData: {
          id: 0,
          name: "",
          description:"",
          resourceCategoryId: 0,
          resourceCategoryName: "",
          moduleGroupId: 0,
          moduleGroupName: "",
          courseClassificationId: 0,
          courseClassificationName: ""
        },
        resourceDropdown: 0,
        resourceList: [],
        gradeDropdown: 0,
        gradeList: [],
        termDropdown: 0,
        termList: [],
        mode: "",
        resourceCardTitle: "",
        counterDanger: false
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.resourceTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.name);
      }
    },
    methods: {
      initValues() {
        this.mode = "";
        this.isInfoHidden = true;
        this.errors.clear();
        this.gradeDropdown = 0;
        this.gradeList = [];
        this.termDropdown = 0;
        this.termList = [];
        this.formData.id= 0,
        this.formData.name= "",
        this.formData.description="",
        this.formData.resourceCategoryId= 0,
        this.formData.resourceCategoryName= "",
        this.formData.moduleGroupId= 0,
        this.formData.moduleGroupName= "",
        this.formData.courseClassificationId= 0,
        this.formData.courseClassificationName= ""

      },
      getTermData(){
        var self = this;

        var onSuccess = response=>{
            self.termList = response.data.map(x=>{
                return{label: x.name, value: x.id}
            });
        };
        self.$ajaxGet(self, "ModuleGroup/ListModuleGroups", onSuccess);
      },
      getGradeData(){
        var self = this;

        var onSuccess = response=>{
            self.gradeList = response.data.map(x=>{
                return{label: x.name, value: x.id}
            });
        };
        self.$ajaxGet(self, "CourseClassification/ListClassifications", onSuccess);
      },
      getResourceData(){
        var self = this;

        var onSuccess = response=>{
            self.resourceList = response.data.map(x=>{
                return{label: x.text, value: x.value}
            });
        };
        self.$ajaxGet(self, "ResourceCategory/List", onSuccess);
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
      },
      saveData() {
        this.initValues();
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      loadData() {
        const self = this;
        self.showLoadingOnElement("resourceTable", 1, "corners");

        var onSuccess = function (response) {
            self.resource = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.resourceTable.$el);
        };
        self.$ajaxGet(self, "additionalResources/List", onSuccess, onFinally);
      },
      showDetailsCard(){
        var self = this;
        self.errors.clear();
        self.initValues();
        self.getTermData();
        self.getGradeData();
        self.getResourceData();
        self.isInfoHidden = false;
        self.mode = "Add New";
        self.resourceCardTitle = "Add Resource";
      },
      handleSelectedResource(resource) {
        var self = this;
        self.getResourceData();
        self.getTermData();
        self.getGradeData();
        self.isInfoHidden = false;
        self.mode = "Update";
        self.resourceCardTitle = "Edit Resource";

        self.formData.id = resource.id;
        self.formData.name = resource.name;
        self.formData.description = resource.description;
        self.resourceDropdown = self.resourceList.filter(function(item){
            return item.value == resource.resourceCategoryId;
        })[0];
        self.termDropdown = self.termList.filter(function(item){
            return item.value == resource.moduleGroupId;
        })[0];
        self.gradeDropdown = self.gradeList.filter(function(item){
            return item.value == resource.courseClassificationId;
        })[0];
      },
      saveEditResource() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnElement("saveEditButton", 0.45, "material");

            var onSuccess = response => {
              self.formData.id = response.data;
              self.saveData();
              if(self.mode != "Add New"){
                self.isInfoHidden = true;
                self.initValues();
              }else {
                self.defaultButtonsHidden = true;
                self.getResourceData();
                self.getTermData();
                self.getGradeData();
                self.$vs.notify({
                  title:'Information',
                  color: "success",
                  text: "Resource Saved",
                  position:'top-right',
                  iconPack: 'feather',
                  icon:'icon-save'
                });
              }
            };
            var onFinally = function () {
                self.$vs.loading.close(self.$refs.saveEditButton.$el);
                
            };
            self.formData.resourceCategoryId = self.resourceDropdown.value;
            self.formData.resourceCategoryName = self.resourceDropdown.label;
            self.formData.moduleGroupId = self.termDropdown ?  this.termDropdown.value: null ;
            self.formData.moduleGroupName = self.termDropdown  ? this.termDropdown.label : null;
            self.formData.courseClassificationId = self.gradeDropdown ?  this.gradeDropdown.value : null;
            self.formData.courseClassificationName = self.gradeDropdown ?  this.gradeDropdown.label : null;

            self.$ajaxPost(self, "additionalResources/AddEdit", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteResource() {
        var self = this;
        self.showLoadingOnElement("deleteButton", 0.45, "material");

        var onSuccess = response => {
          self.saveData();
          self.initValues();
          self.errors.clear();
          self.isInfoHidden = true;
          self.scrollToNavbar();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Resource Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };
        self.formData.id = parseInt(self.formData.id);
        self.$ajaxDelete(self, "DeleteAdditionalResources/Delete/" + self.formData.id, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
    },
    mounted() {
      var self = this;
      self.getTermData();
      self.getGradeData();
      self.getResourceData();
      self.loadData();
      self.isMounted = true;
    },
  }

</script>